/** Parse the logout response into a browser navigation, never an executable URL. */
export function parseLogoutRedirect(
  value: unknown,
  appOrigin: string,
): URL | null {
  if (
    value === null ||
    typeof value !== "object" ||
    !("redirect_url" in value) ||
    typeof value.redirect_url !== "string"
  )
    return null;

  try {
    const target = new URL(value.redirect_url, appOrigin);
    const localHttp =
      target.protocol === "http:" &&
      (target.origin === appOrigin ||
        ["localhost", "127.0.0.1", "[::1]"].includes(target.hostname));
    if (target.username !== "" || target.password !== "") return null;
    if (target.protocol !== "https:" && !localHttp) return null;
    // The server chooses the provider. Relative responses are only its local fallback.
    if (
      !URL.canParse(value.redirect_url) &&
      value.redirect_url !== "/?logout=local"
    )
      return null;
    return target;
  } catch {
    return null;
  }
}
